import React from 'react';
import { Link } from 'react-router-dom';

const HomepageBanner = () => {
  return (
    <section className='hero-banner'>
      <div className='hero-banner__inner'>
        <div className='hero-banner__content'>
          <p className='hero-banner__subtitle'>
            INKJET &bull; LASER &bull; ALL-IN-ONE PRINTERS
          </p>
          <h1 className='hero-banner__title'>
            Find the Perfect Printer for Every Need
          </h1>
          <p className='hero-banner__desc'>
            Browse top-rated printers from trusted brands — whether it's for
            home, office, or high-volume work, we've got you covered with
            genuine products and hassle-free checkout.
          </p>
          <Link to='/about-us' className='hero-banner__btn'>
            Shop Printers
          </Link>
          <div className='hero-banner__badges'>
            <a
              href='https://locator.hp.com/us/en/?ml___task=search_zip&ml___id=570276&ml___ml_skip_interstitial=1&ml___url_share_action=1&ml___lang=en-US%20(1)&ml___redirect_commercial_destination_Itemid=1'
              target='_blank'
            >
              <img
                src='/images/hp-partner.png'
                alt='HP'
                style={{ height: 80 }}
              />
            </a>
            <div
              style={{
                background: '#fff',
                padding: '10px 20px',
                borderRadius: '8px',
              }}
            >
              <a
                href='https://www.trustpilot.com/review/itfixed247.com'
                target='_blank'
              >
                <img
                  src='/images/trustpilot.png'
                  alt='HP'
                  style={{ height: 45 }}
                />
              </a>
            </div>
          </div>
        </div>
        <div className='hero-banner__image'>
          <img
            src='/images/404dn.jpeg'
            alt='Printer'
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default HomepageBanner;
